import React, { Component, useState, useEffect } from "react";
import cookie from "react-cookies";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "@windmill/react-ui";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { DeleteReduxDataCti } from "src/api/Actions/ServiceCTI/DeleteReduxDataCti";
import Swal from "sweetalert2";
import {
  GetCtiTicketField,
  SaveTicketField,
} from "../../api/Actions/ServiceCTI";

const FreshsalesFields = () => {
  const dispatch = useDispatch();
  let [NestedChild, setNestedChild] = useState({});
  let [SelectedField, setSelectedField] = useState({});
  const [SelectedMonth, setSelectedMonth] = useState();
  const [OpenDatepicker, setOpenDatepicker] = useState(false);
  let [DataChoices, setDataChoices] = useState({});

  const GetTicket = useSelector(
    (state) => state.CtiCredential.GetCtiTicketField
  );
  const ctiType = useSelector((state) => state.ReduxState.ctiType);
  const isModalOpen = useSelector((state) => state.ReduxState.TicketFieldModal);
  const LoadingTicketField = useSelector(
    (state) => state.ReduxState.LoadingTicketField
  );

  //handle save update field
  const handleSubmit = () => {
    const org = localStorage.getItem("orgUuid");
    const dataReq = {
      orgUuid: org,
      custom_field: [],
    };
    // console.log(SelectedField, "selected value");

    for (const [key, value] of Object.entries(SelectedField)) {
      if (key !== "undefined") {
        if (value !== "null") {
          let type = "";
          if (typeof value["value"] === "number") {
            type = "number";
            // console.log(value["value"], "dia number");
          } else {
            type = `${typeof value["value"]}`;
          }
          let fieldData = {
            field: `${key}`,
            value: `${value["value"]}`,
            typeValue: type,
            type: 2,
            status: 1,
          };
          dataReq.custom_field.push(fieldData);
        }
      }
    }
    dispatch(SaveTicketField(ctiType, dataReq));
  };

  //handle save update field
  const handleNested = (fieldName, selected, type, parent) => {
    switch (type) {
      case "dropdown":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: selected,
        }));
        break;

      case "nested_1":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: selected,
          [NestedChild[fieldName][0]]: { value: null, label: "--" },
          [NestedChild[fieldName][1]]: { value: null, label: "--" },
        }));
        break;

      case "nested_2":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: selected,
          [NestedChild[parent][1]]: { value: null, label: "--" },
        }));
        break;

      case "nested_3":
        // console.log(fieldName, selected, "nesterd terakhir");
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: selected,
        }));

        break;

      case "textarea":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: { value: selected.target.value, label: "--" },
        }));

        break;

      case "checkbox":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: { value: selected.target.checked, label: "--" },
        }));

        break;

      case "number":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: {
            value: Math.round(selected.target.value),
            label: "--",
          },
        }));

        break;

      case "decimal":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: { value: Number(selected.target.value), label: "--" },
        }));

        break;

      case "date":
        setOpenDatepicker(!OpenDatepicker);
        const datetoconvert = selected;
        const tzoffset = new Date().getTimezoneOffset() * 60000;
        const StartReportPeriod = new Date(selected - tzoffset)
          .toISOString()
          .split("T")[0];
        // const EndReportPeriod = new Date(SelectedMonth);
        // setSelectedMonth(selected);
        // console.log(SelectedField, "FIELDNAME");
        SelectedField[fieldName].value = StartReportPeriod;
        break;

      case "text":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: { value: selected.target.value, label: "--" },
        }));
        break;

      default:
        break;
    }
  };

  //set remove integration button on/off
  useEffect(() => {
    if (GetTicket) {
      // console.log(GetTicket, " ini data getticket gays");
      if (GetTicket.data.length > 0) {
        const optionsData = {};
        const nestedChildData = {};
        const fieldList = {};
        GetTicket.data[0].rows.ticket_fields.forEach((element) => {
          fieldList[element.name] = { value: null, label: "--" };
          let array = [{ value: null, label: "--" }];
          let arrayNestedChild = [];
          // jika element memiliki choices
          if (element.choices || element.system_field_options) {
            // jika tipe choices dari data adalah array
            if (element.choices && Array.isArray(element.choices)) {
              // console.log(element.choices, "INI ASDASDASDASDASDASDASDASD cois");
              element.choices.forEach((a) => {
                let object = { value: a, label: a };
                array.push(object);
              });

              optionsData[element.name] = array;
            } else if (
              element.system_field_options &&
              Array.isArray(element.system_field_options)
            ) {
              // console.log(
              //   element.choices,
              //   "INI ASDASDASDASDASDASDASDASD system field"
              // );
              element.system_field_options.forEach((a) => {
                let object = { value: a.value, label: a.name };
                array.push(object);
              });

              optionsData[element.name] = array;
            } else {
              // jika tipe choices dari data adalah object
              if (element.type === "nested_field") {
                //untuk nampung data selected
                for (
                  let index = 0;
                  element.nested_ticket_fields.length > index;
                  index++
                ) {
                  arrayNestedChild.push(
                    element.nested_ticket_fields[index].name
                  );

                  fieldList[arrayNestedChild[index]] = {
                    value: null,
                    label: "--",
                  };
                }
              }

              for (const [key, value] of Object.entries(element.choices)) {
                if (element.type === "default_status") {
                  // console.log("MASUK KE DEFAULT STATUS");
                  let object = { value: Number(key), label: value[0] };

                  array.push(object);
                } else if (element.type === "nested_field") {
                  let subObject = value; //ini yang harus di looping

                  const ChildName = `${arrayNestedChild[0]}_${key.replace(
                    " ",
                    "_"
                  )}`;

                  let array2 = [{ value: null, label: "--" }];
                  let object = { value: key, label: key };
                  array.push(object);

                  for (const [key1, value1] of Object.entries(subObject)) {
                    const GrandChildName = `${
                      arrayNestedChild[1]
                    }_${key1.replace(" ", "_")}`;

                    let array3 = [{ value: null, label: "--" }];
                    let object2 = { value: key1, label: key1 };
                    array2.push(object2);

                    for (const [key2, value2] of Object.entries(value1)) {
                      let object3 = { value: value2, label: value2 };
                      array3.push(object3);
                    }
                    optionsData[GrandChildName] = array3;
                  }
                  optionsData[ChildName] = array2;
                } else {
                  // console.log("MASUK KE SINI yang status");
                  let object = { value: value, label: key };
                  // console.log(object, "INI OBJECTNYA");
                  array.push(object);
                }

                //console.log(optionsData, 'options data');
                nestedChildData[element.name] = arrayNestedChild;
                optionsData[element.name] = array;
              }
            }
          } else {
          }
        });
        //console.log(optionsData, 'data optionsnnya coy')
        // console.log(optionsData, "OPTIONS DATA");
        setSelectedField(fieldList);
        setNestedChild(nestedChildData);
        setDataChoices(optionsData);
      }
    }
    dispatch({ type: "set", LoadingTicketField: false });
  }, [GetTicket]);

  // useEffect(() => {
  //   if (CreateTicket !== false) {
  //     if (CreateTicket.success === true) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Ticket Field Updated",
  //       });
  //       // dispatch(DeleteReduxDataCti());
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Please check required fields",
  //       });
  //       // dispatch(DeleteReduxDataCti());
  //     }
  //   }
  // }, [CreateTicket]);

  //console.log(DataChoices, "pilihan datanya");
  // console.log(SelectedField, "selected");
  // console.log(NestedChild, "nested childddddddddddd");
  // console.log(CreateTicket, "respond create ticket");
  // console.log(GetTicket.data, "ini datanya");

  return (
    <>
      <form>
        {GetTicket.data
          ? GetTicket.data[0].rows.ticket_fields.map((data, id) => {
              return (
                <div className="flex flex-col w-full p-2 my-2 " key={id}>
                  <label className="flex my-auto font-bold text-sm">
                    {/* ticket field name */}
                    <p className="font-bold text-lg">{data.label}</p>
                    {/* if data is required */}
                    {data.required || data.required_for_agents ? (
                      <p className="text-red-500 font-bold ml-2 text-xs">
                        *Required
                      </p>
                    ) : (
                      ""
                    )}
                  </label>
                  {/* if field type is dropdown or default_status */}
                  {data.type === "dropdown" ||
                  data.type === "custom_dropdown" ? (
                    <div className="relative">
                      <Select
                        defaultValue={"Select Option"}
                        options={DataChoices[data.name]}
                        onChange={(selected) =>
                          handleNested(data.name, selected, "dropdown")
                        }
                      />
                    </div>
                  ) : data.type === "nested_field" ? (
                    // parent
                    <div className="relative">
                      <Select
                        options={DataChoices[data.name]}
                        onChange={(selected) =>
                          handleNested(data.name, selected, "nested_1")
                        }
                      />
                      {NestedChild[data.name] &&
                      NestedChild[data.name].length > 0 ? (
                        <div className="border-l border-gray-300">
                          {/* child */}
                          {SelectedField[data.name] &&
                          SelectedField[data.name].value !== null ? (
                            <div className="ml-2 mt-2">
                              <label className="flex my-auto font-bold text-sm">
                                {NestedChild[data.name][0] &&
                                NestedChild[data.name][0].indexOf("cf_") !== -1
                                  ? NestedChild[data.name][0].split("cf_")
                                  : ""}
                              </label>
                              <Select
                                options={
                                  DataChoices[
                                    `${
                                      NestedChild[data.name][0]
                                    }_${SelectedField[data.name][
                                      "value"
                                    ].replace(" ", "_")}`
                                  ]
                                }
                                value={SelectedField[NestedChild[data.name][0]]}
                                onChange={(selected) =>
                                  handleNested(
                                    NestedChild[data.name][0],
                                    selected,
                                    "nested_2",
                                    data.name
                                  )
                                }
                              />
                              {/* grandchild */}
                              {NestedChild[data.name] &&
                              NestedChild[data.name].length > 1 ? (
                                <div>
                                  {SelectedField[NestedChild[data.name][0]] &&
                                  SelectedField[NestedChild[data.name][0]][
                                    "value"
                                  ] !== null ? (
                                    <div className="ml-2 mt-2">
                                      <label className="flex my-auto font-bold text-sm">
                                        {NestedChild[data.name][1] &&
                                        NestedChild[data.name][1].indexOf(
                                          "cf_"
                                        ) !== -1
                                          ? NestedChild[data.name][1].split(
                                              "cf_"
                                            )
                                          : ""}
                                      </label>
                                      <Select
                                        options={
                                          DataChoices[
                                            `${
                                              NestedChild[data.name][1]
                                            }_${SelectedField[
                                              NestedChild[data.name][0]
                                            ]["value"].replace(" ", "_")}`
                                          ]
                                        }
                                        value={
                                          SelectedField[
                                            NestedChild[data.name][1]
                                          ]
                                        }
                                        onChange={(selected) =>
                                          handleNested(
                                            NestedChild[data.name][1],
                                            selected,
                                            "nested_3",
                                            data.name
                                          )
                                        }
                                      />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : data.type === "textarea" ||
                    data.type === "custom_paragraph" ? (
                    <div className="relative">
                      <textarea
                        onChange={(selected) =>
                          handleNested(data.name, selected, "textarea")
                        }
                        className="resize-none w-full mb-2 h-40 border-gray-300 border rounded focus:ring-0 outline-none"
                      ></textarea>
                    </div>
                  ) : data.type === "checkbox" ||
                    data.type === "custom_checkbox" ? (
                    <div className="relative">
                      <input
                        onChange={(selected) =>
                          handleNested(data.name, selected, "checkbox")
                        }
                        type="checkbox"
                        className="resize-none mb-2 w-4 h-4 border-gray-300 border rounded focus:ring-0 outline-none"
                      ></input>
                    </div>
                  ) : data.type === "number" ||
                    data.type === "custom_number" ? (
                    <div className="relative">
                      <input
                        onChange={(selected) =>
                          handleNested(data.name, selected, "number")
                        }
                        min="0"
                        step="1"
                        // value=""
                        type="number"
                        className="resize-none mb-2 w-full h-10 border-gray-300 border rounded focus:ring-0 outline-none"
                      ></input>
                    </div>
                  ) : data.type === "decimal" ||
                    data.type === "custom_decimal" ? (
                    <div className="relative">
                      <input
                        onChange={(selected) =>
                          handleNested(data.name, selected, "decimal")
                        }
                        min="0"
                        type="number"
                        step="0.1"
                        className="resize-none mb-2 w-full h-10 border-gray-300 border rounded focus:ring-0 outline-none"
                      ></input>
                    </div>
                  ) : data.type === "date" || data.type === "custom_date" ? (
                    <DatePicker
                      dateFormat="dd MMMM yyyy"
                      //showMonthYearPicker
                      disabled={false}
                      placeholderText="Select Date"
                      popperPlacement="bottom"
                      showPopperArrow={false}
                      open={OpenDatepicker}
                      inline={true}
                      // selected={SelectedMonth}
                      onInputClick={() => setOpenDatepicker(!OpenDatepicker)}
                      onChange={(selected) =>
                        handleNested(data.name, selected, "date")
                      }
                      className="flex mx-auto text-center border-gray-300 rounded outline-none focus:ring-0"
                    />
                  ) : (
                    <input
                      onChange={(selected) =>
                        handleNested(data.name, selected, "text")
                      }
                      type="text"
                      className="mb-2 h-10 border-gray-300 border rounded focus:ring-0 outline-none"
                    ></input>
                  )}
                </div>
              );
            })
          : ""}
        <div className="flex mt-10">
          {GetTicket && GetTicket.data ? (
            <div className="mx-auto">
              {GetTicket.data[0].rows.ticket_fields.length > 0 ? (
                <button
                  onClick={(e) => handleSubmit(e)}
                  type="button"
                  className="mx-auto w-40 rounded-lg h-10 bg-main-blue text-white font-bold"
                >
                  Save
                </button>
              ) : (
                <p className="text-center">
                  Don’t have any custom ticket fields on your CRM Account
                </p>
              )}
            </div>
          ) : (
            <div className="mx-auto">
              <p className="text-center">
                Please check again your credentials.
              </p>
            </div>
          )}
        </div>
      </form>
    </>
  );
};

export default FreshsalesFields;
